import { useMutation } from '@tanstack/react-query';

/**
 * Mutation hook for persisting bulk upload data.
 *
 * @param {Object} options
 * @param {Object} options.api - API object with persist function
 * @param {Object} options.params - Additional params to pass to the API
 * @param {string|null} options.uploadKey - The bulk upload key
 * @param {Function} [options.onSuccess] - Callback when persist succeeds
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
function usePersistUpload({ api, onSuccess, params, uploadKey }) {
    return useMutation({
        mutationFn: async () => {
            const response = await api.persist(uploadKey, params);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Persist failed');
            }
            return response.data;
        },
        onSuccess,
    });
}

export { usePersistUpload };
